import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  track(event) {
    const { name, ...properties } = event.params
    if (!name) return

    const appVersion = document.body.dataset.appVersion
    const analytic = { name, properties }

    if (appVersion) analytic.app_version = appVersion

    const payload = new Blob(
      [JSON.stringify({ analytic })],
      { type: "application/json" }
    )

    navigator.sendBeacon("/api/analytics/track", payload)
  }
}
